import React from 'react'
import NavLink from '../Routes/NavLink'
import {stateRules} from '../../core/controllers/StateRules'

export default class StatesSelect extends React.Component {
    constructor(props) {
        super(props);

        var mdColSize = 4;
        var smColSize = 6;
        var xsColSize = 12;
        var title = "Select a State:";
        var sortID = 0;
        
        if (this.props.mdColumnSize !== undefined) {
            mdColSize = this.props.mdColumnSize;
        } if (this.props.smColumnSize !== undefined) {
            smColSize = this.props.smColumnSize;
        } if (this.props.xsColumnSize !== undefined) {
            xsColSize = this.props.xsColumnSize;
        } if (this.props.title !== undefined) {
            title = this.props.title;
        } if (this.props.sortID !== undefined) {
            sortID = this.props.sortID;
        }

        this.options = {
            columnSize: "col-md-" + mdColSize + " col-sm-" + smColSize + " col-xs-" + xsColSize,
            title: title,
            sortID: sortID
        }
    }

    componentDidMount() {
        stateRules.getStateRules(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined) {
            this.options.sortID = nextProps.sortID;
        } else {
            this.options.sortID = nextProps.sortID;
        }
    }

    render(){
        // #  Implement functionality to have tenant select list auto select selectID passed in, if one does
        const statesList = this.state;
        const options = this.options;

        return (
            <div class={options.columnSize}>
                <small>{options.title}</small>
                <select class="form-control" value={options.sortID} onChange={this.props.onChange}>
                    <option value="0">Select a State</option>
                    {statesList != null && ( 
                        statesList.data.map(function(state, index){
                                return <option value={state.state_rules_id} key={state.state_rules_id}>
                                    {state.state_rules_name}
                                </option>
                            })
                        )
                    }
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/States/StatesSelect.jsx